import { useEffect, useState } from "react";

import { useFormik } from "formik";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Message } from "primereact/message";
import { Sidebar } from "primereact/sidebar";

import { convertSumWithLatestCurrencyRate, formatShortDate, systemPaymentMethods } from "../../../Utils/Utils";
import CurrencyAmountInput from "../Inputs/CurrencyAmountInput";
import useApi from "../../../Utils/BackendClient";

import commonStyle from "../../content/CommonStyles.module.css"; 

const PaymentSideBar = ({ visible, onHide, onMessage, data, moneyMovementType, reloadData, isExternalAct}) => {

    const { createPayment, fetchActUnpaidBalance } = useApi();

    const [unDividedSum, setUnDividedSum] = useState(0);
    const [totalSumUAH, setTotalSumUAH] = useState(0);
    const [paymentData, setPaymentData] = useState(
        {
            id: null,
            cagent_id: null,
            payments: []
        }
    )

    const formik = useFormik({
        initialValues: paymentData,
        enableReinitialize: true,
        validate: values => {
            const errors = {};

            values.payments.forEach((payment, index) => {
                if (payment.paymentMethod === null || payment.paymentMethod === '') {
                    if (!errors.payments) errors.payments = [];
                    errors.payments[index] = { paymentMethod: 'Вкажіть спосіб оплати' };
                }
            });

            return errors
        },
        onSubmit: values => {

            let paymentRequest = [];

            values.payments.forEach(payment => {

               const singlePaymentRequest = {
                  date: formatShortDate(Date.now()),
                  sum: payment.sum,
                  currency: payment.currency,
                  type: systemPaymentMethods[payment.paymentMethod],
                  method: moneyMovementType,
                  cagent_id: values.cagent_id != null ? values.cagent_id : null,
               }

               if(isExternalAct){
                  singlePaymentRequest.external_sale_act_id = values.id;
                  singlePaymentRequest.purpose = "PAYMENT"
               }
               else{
                  singlePaymentRequest.act_id = values.id
               }

               paymentRequest.push(singlePaymentRequest);
            });

            const callBackEnd = async () => {

                const response = await createPayment(paymentRequest);

                if (response.status === 201) {
                    onMessage({severity: "success", summary: 'Оплата', detail: 'Оплата пройшла успішно', life: 2000});
                    reloadData();
                    onHide();
                }
                else if (response.status === 403) {
                    onMessage({ severity: "error", summary: "Помилка продажу", detail: "Користувач не має прав проводити оплату", life: 3000 });
                }
                else {
                    onMessage({ severity: "error", summary: "Помилка продажу", detail: "Помилка створення платежу у валюті, код помилки:" + response.status, life: 3000 });
                }
            }

            callBackEnd();
        }
    });

    useEffect(() => {

        if (data !== null) {
            const fetchActDetails = async () => {
                const response = await fetchActUnpaidBalance(data.id, isExternalAct);

                if (response.status === 200) {

                    let paymentObject = {};
                    paymentObject.id = data.id;
                    paymentObject.cagent_id = data.cagent;

                    let amountUAH = 0;

                    const paymentsToPass = [];
                    response.data.forEach(payment => {
                        if (payment.sum !== 0) {
                            amountUAH += convertSumWithLatestCurrencyRate(payment.currency, payment.sum);
                            payment.paymentMethod = null;
                            paymentsToPass.push(payment);
                        }
                    });
                    paymentObject.payments = paymentsToPass;
                    setPaymentData(paymentObject);
                    setTotalSumUAH(amountUAH);
                }
                else {
                    onMessage({ severity: "error", summary: 'Помилка отримання даних', detail: `Помилка отримання даних акту ${data.id}`, life: 3000 });
                }
            }

            fetchActDetails();
        }
    }, [data, isExternalAct, fetchActUnpaidBalance, onMessage]);

    useEffect(() => {
        let convertedAmount = 0;
  
        if (formik.values.payments.length !== 0) {
           formik.values.payments.forEach(payment => {
              convertedAmount += convertSumWithLatestCurrencyRate(payment.currency, payment.sum)
           });
        }
        
        setUnDividedSum(totalSumUAH - convertedAmount);
  
    }, [formik.values.payments, formik.values.discount, totalSumUAH]);

    const addPaymentToFormik = () => {
        const newPayment = [
           ...formik.values.payments,
           { currency: "UAH", sum: 0.00, paymentMethod: null }
        ];
        formik.setFieldValue('payments', newPayment);
    };

    const handleParameterChange = (index, parameter, value) => {
        const newPayments = [...formik.values.payments];
        newPayments[index][parameter] = value;
        formik.setFieldValue('payments', newPayments);
    }

    const deletePayment = (index) => {
        const newPayments = [...formik.values.payments];
        newPayments.splice(index, 1);
        formik.setFieldValue('payments', newPayments);
    };

    return (<Sidebar className={`${commonStyle.paymentSidebar}`} header="Оплата товару" visible={visible} position="right" onHide={onHide}>
        <form onSubmit={formik.handleSubmit}>
            {formik.values.payments.length === 0 && (
                <div className="mb-2">
                    <Message className='sideBarMessage' severity="error" text="Додайте валюту і спосіб оплати" />
                </div>
            )}
            {formik.values.payments.map((currencyAmount, index) => (
                <div className="grid py-3" key={index}>
                    <CurrencyAmountInput
                        amount={currencyAmount.sum}
                        currency={currencyAmount.currency}
                        onAmountChange={val => handleParameterChange(index, "sum", val)}
                        onCurrencyChange={val => handleParameterChange(index, "currency", val)}
                        customStyle="col-10 p-inputgroup py-0 flex-1"
                    />
                    <div className="col-2 flex justify-content-center align-items-center">
                        <Button className="noStyleButton" icon="pi pi-trash" severity="danger" type='button' text onClick={() => deletePayment(index)} />
                    </div>
                    <div className="col-12 py-0">
                        <Dropdown
                            className={formik.errors.payments && formik.errors.payments[index] && formik.touched.payments && formik.touched.payments[index] ? `${commonStyle.fullWidth} p-invalid` : `${commonStyle.fullWidth}`}
                            value={currencyAmount.paymentMethod}
                            onChange={e => handleParameterChange(index, "paymentMethod", e.value)}
                            options={Object.keys(systemPaymentMethods)}
                            placeholder="Спосіб оплати"
                        />
                        {formik.errors.payments && formik.errors.payments[index] && formik.touched.payments && formik.touched.payments[index] && (
                            <small className={commonStyle.errorSmall}>{formik.errors.payments[index].paymentMethod}</small>
                        )}
                    </div>
                </div>
            ))}
            <div className='mb-2'>
                <Message className={commonStyle.fullWidth} severity={unDividedSum > 0 ? "warn" : "success"} text={`Нерозподілена сума: ${unDividedSum} грн.`} />
            </div>
            <div>
                <Button label="+ Додати валюту" severity="info" type="button" className={`${commonStyle.fullWidth} ${commonStyle.editButton}`} onClick={addPaymentToFormik} />
                {formik.values.payments.length !== 0 && <Button label="Оплатити" severity="success" type="submit" className={`${commonStyle.fullWidth} ${commonStyle.addButton} mt-1`} />}
            </div>
        </form>
    </Sidebar>);
}

export default PaymentSideBar;